<template>
  <div :class="['golf-outer', showLoader ? '' : 'loaded']">
    <div class="home-page game-outer">
      <div id="mySidenav" class="cross-btn">
        <a class="closebtn" @click="$emit('hidepopup')">&times;</a>
      </div>
      <div class="club-details">
        <div class="club-img" v-if="adminClubInfo &&  adminClubInfo.data && adminClubInfo.data.club_info && adminClubInfo.data.club_info.image_url">
          <img v-bind:src="adminClubInfo.data.club_info.image_url" alt="club"/>
        </div>
        <div class="club-name" v-if="adminClubInfo &&  adminClubInfo.data && adminClubInfo.data.club_info && adminClubInfo.data.club_info.name">
        {{adminClubInfo.data.club_info.name}}</div>
      </div>
      <div class="table-content-inner">
        <div class="table-content" v-if="adminClubInfo && adminClubInfo.data && adminClubInfo.data.users &&
        adminClubInfo.data.users.length > 0">
          <table>
            <tr class="list-head">
              <th>Name</th>
              <th>Current Level</th>
              <th>Level Points</th>
              <th>Quiz Completed</th>
            </tr>
              <tr v-for="(user,index) in adminClubInfo.data.users" :key="index">
                <td>{{user.name}}</td>
                <td>
                  <span v-if="user.current_level=='Prime'">Regluvörður</span>
                  <span v-if="user.current_level=='Gold'">Atvinnumaður</span>
                  <span v-if="user.current_level=='Silver'">Áhugamaður</span>
                  <span v-if="user.current_level=='Bronze'">Byrjandi</span>
                </td>
                <td>{{user.level_points}}</td>
                <td>{{user.quiz_completed}}</td>
              </tr>
          </table>
          <pagination
          v-if="adminClubInfo && adminClubInfo.total_pages && adminClubInfo.total_pages > 1"
          :pagination="adminClubInfo"
          @paginate="pageQuery = $event"></pagination>
        </div>
        <div v-else class="no-users">No Players in this Club</div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/shared/api'
export default {
  name: 'AdminClubInfo',
  props: ['clubKey'],
  data () {
    return {
      showLoader: false,
      adminClubInfo: null,
      showPagination: true,
      pageQuery: 1,
      dataReady: true
    }
  },
  created () {
    if (this.$route.query.page) {
      this.pageQuery = this.$route.query.page
    }
    this.getAdminClubInfo()
  },
  watch: {
    '$route' (to, from) {
      this.getAdminClubInfo()
    },
    pageQuery () {
      this.refreshData ()
    }
  },
  methods: {
    refreshData () {
      this.$router.replace({ query: { 'page': this.pageQuery } })
    },
    getAdminClubInfo () {
      let queryParams = {
        'page': this.pageQuery
      }
      API.meInstance.get('/club/' + this.clubKey + '/players/', { params: queryParams }).then((res) => {
        if (res) {
          this.adminClubInfo = res.data
        }
        this.dataReady = true
      }).catch((error) => {
        console.log('Error loading', error)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .title {
    padding-top: 50px;
  }
  .no-users {
    text-align: center;
    padding: 50px;
    font-size: 30px;
    color: #333333c9;
  }
  .club-name {
    display: inline-block;
    vertical-align: middle;
  }
  .club-details {
    text-align: center;
    padding-top: 75px;
  }
  .table-content {
    padding: 20px;
    overflow-x: auto;
  }
  table {
    border-collapse: collapse;
    width: 100%;
    margin: 20px 0;
  }
  td, th {
    text-align: left;
    padding: 8px;
  }
  td {
    background: #F7F7F3;
    border-top: 1px solid #EAEAE3;
    border-bottom: 1px solid #EAEAE3;
  }
  .cross-btn {
    position: relative;
    z-index: 1;
    a {
      float: right;
      background: #FCBD00;
      padding: 10px 20px;
      font-size: 25px;
      color: #696865;
      cursor: pointer;
      &:hover {
        text-decoration: none;
      }
    }
  }
  @media (max-width: 767px) {
    th , td{
      font-size: 14px;
    }
  }
</style>
